export { default } from './HeartLoader';
